import { createContext, useContext } from "react";

export const AdminPortalContext = createContext(null);

export const useAdminPortal = () => {
  const context = useContext(AdminPortalContext);

  if (!context) {
    throw new Error("useAdminPortal must be used within AdminPortalContext");
  }

  return context;
};
